export default __webpack_public_path__ + "static/media/prediction.daca8d7c.svg";